import React from 'react';
import { Menu } from 'semantic-ui-react';
import { Route, Link } from 'react-router-dom';
import configRoutes from 'router/configRoutes';

const SideNavBar = ({ isOpen, toggleSidebar, category }) => (
  <nav className={isOpen ? 'open' : 'closed'} onClick={toggleSidebar}>
    <Menu fluid vertical icon="labeled" inverted>
      {configRoutes(category)
        .filter(r => r.visible)
        .map(route => (
          <Route
            key={route.path}
            exact={route.exact}
            path={route.path}
            children={({ match }) => (
              <Menu.Item
                as={Link}
                to={route.link || route.path}
                active={!!match}
              >
                {route.label}
              </Menu.Item>
            )}
          />
        ))}
    </Menu>
  </nav>
);

export default SideNavBar;
